export default "__VITE_ASSET__DlZDTUux__"